module.exports = __webpack_public_path__ + "static/media/menu.2a0ab45d.svg";